module.exports = __webpack_public_path__ + "static/shareFanWater3BG-b32bd72c05676c967159169166bc6655.png";